import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const postImage = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.SOCIAL.EDIT_POLL, data);
};

export default postImage;
